import "./index.marko?deps"
import { register } from "marko/components"
import component from "./component-browser.js"
register("NmhIkHrL", component)
import "../ebay-badge/index.marko?hydrate"